import React, { useState } from "react";
import "./Subscriptions.scss";
import { Button, Radio, Segmented, Table } from "antd";
import checkCircle from "@assets/icons/check-circle.svg";
import crown from "@assets/icons/crown.svg";
import SearchSetting from "@components/SearchSetting/SearchSetting";
import { useUnit } from "contexts/UnitContext";

const Subscriptions: React.FC = () => {
  const [subscription, setSubscription] = useState("free");
  const [subscriptionPlan, setSubscriptionPlan] = useState("1 Month");
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const { units } = useUnit();

  const handleSelectPlan = (value: string) => {
    setSubscription(value);
  };

  interface Features {
    key: number;
    feature: any;
    free: any;
    premium: any;
  }

  const data: Features[] = [
    {
      key: 1,
      feature: <b>General</b>,
      free: "",
      premium: "",
    },
    {
      key: 1.1,
      feature: (
        <div className="feature-group">
          <div className="group-title">Hide Ads</div>
          <div className="group-title">Producer Details</div>
        </div>
      ),
      free: (
        <div className="feature-group">
          <div>-</div>
          <div>-</div>
        </div>
      ),
      premium: (
        <div className="feature-group">
          <img src={checkCircle} alt="check-circle" width="16px" />
          <img src={checkCircle} alt="check-circle" width="16px" />
        </div>
      ),
    },
    {
      key: 2,
      feature: <b>Image Gallery (Uploads)</b>,
      free: "",
      premium: "",
    },
    {
      key: 2.1,
      feature: (
        <div className="feature-group">
          <div className="group-title">Farm Pictures</div>
          <div className="group-title">Profiles</div>
          <div className="group-title">Banner</div>
          <div className="group-title">Product</div>
          <div className="group-title">Video</div>
        </div>
      ),
      free: (
        <div className="feature-group">
          <div>3</div>
          <div>3</div>
          <div>2</div>
          <div>10</div>
          <div>1</div>
        </div>
      ),
      premium: (
        <div className="feature-group">
          <div>10</div>
          <div>6</div>
          <div>4</div>
          <div>25</div>
          <div>10</div>
        </div>
      ),
    },
    {
      key: 3,
      feature: <b>User Profile</b>,
      free: "",
      premium: "",
    },
    {
      key: 3.1,
      feature: (
        <div className="feature-group">
          <div className="group-title">Change Profile Name</div>
        </div>
      ),
      free: "-",
      premium: (
        <div className="feature-group">
          <img src={checkCircle} alt="check-circle" width="16px" />
        </div>
      ),
    },
    {
      key: 4,
      feature: <b>Product Registration</b>,
      free: "",
      premium: "",
    },
    {
      key: 4.1,
      feature: (
        <div className="feature-group">
          <div className="group-title">“Consumer pick-up” Option</div>
          <div className="group-title">Posting Products</div>
        </div>
      ),
      free: (
        <div className="feature-group">
          <div>-</div>
          <div>5</div>
        </div>
      ),
      premium: (
        <div className="feature-group">
          <img src={checkCircle} alt="check-circle" width="16px" />
          <div>Unlimited</div>
        </div>
      ),
    },
  ];

  return (
    <div className="Subscriptions">
      <SearchSetting />
      <div className="title">
        Subscriptions
        <div className="subscription-plan">
          <Segmented
            size={"middle"}
            options={[
              { label: "Monthly", value: "1 Month" },
              {
                label: (
                  <div className="sale-offer-group">
                    Annually
                    <div className="sale-offer">-20%</div>
                  </div>
                ),
                value: "12 Months",
              },
            ]}
            value={subscriptionPlan}
            onChange={(value) => setSubscriptionPlan(value)}
          />
        </div>
      </div>

      <Radio.Group
        className={"subscription-group"}
        onChange={(e) => handleSelectPlan(e.target.value)}
        defaultValue="free"
        options={[
          {
            value: "free",
            label: (
              <div
                className={`subscription-item ${
                  subscription === "free" && "active"
                }`}
              >
                <div className="subscription-name">
                  <span>Free</span>
                </div>
                <div className="subscription-price">
                  <div className="price-group">
                    $0.00
                    <span className="price-unit">/month</span>
                  </div>
                </div>
                <Button disabled className="upgrade-btn">
                  Current plan
                </Button>
                <div className="subscription-detail">
                  <div className="detail-title">General Perks</div>
                  <div className="description-group">
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Standard media uploads
                    </span>
                  </div>
                  <br />
                  <div className="detail-title">Producer Perks</div>
                  <div className="description-group">
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Basic Producer Hub
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Basic Product Registration
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Posting 3-5 products
                    </span>
                  </div>
                </div>
              </div>
            ),
          },
          {
            value: "premium",
            label: (
              <div
                className={`subscription-item ${
                  subscription === "premium" &&
                  subscriptionPlan === "1 Month" &&
                  "active"
                }`}
              >
                <div className="subscription-name">
                  <span className="premium-tag">
                    <img src={crown} alt="crown" width="12px" /> Premium
                  </span>
                </div>
                <div className="subscription-price">
                  <div className="price-group">
                    {subscriptionPlan === "1 Month" ? <>$49.98</> : <>$39.98</>}

                    <div className="price-unit">/month</div>
                  </div>
                  <div className="origin-price">
                    {subscriptionPlan === "12 Months" ? <>$49.98</> : ""}
                  </div>
                </div>
                <Button className="upgrade-btn">Upgrade plan</Button>
                <div className="subscription-detail premium-tag">
                  <div className="detail-title">General Perks</div>
                  <div className="description-group">
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Extended media uploads
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Change profile name
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Hide ads
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      See producer details
                    </span>
                  </div>
                  <br />
                  <div className="detail-title">Producer Perks</div>
                  <div className="description-group">
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Extended Producer Hub
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Basic Product Registration
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Extended Product Registration
                    </span>
                    <span className="description-item">
                      <img src={checkCircle} alt="check-circle" width="16px" />
                      Auction boost announcements
                    </span>
                  </div>
                </div>
              </div>
            ),
          },
        ]}
      />

      <div className="all-features">
        <div
          className="show-features"
          onClick={(e) => {
            e.preventDefault();
            setShowAllFeatures(!showAllFeatures);
          }}
        >
          {showAllFeatures ? "Hide All Features" : "See All Features"}
        </div>
        {showAllFeatures && (
          <Table
            className="features-table"
            columns={[
              {
                title: " ",
                dataIndex: "feature",
                key: "feature",
                align: "left",
              },
              {
                title: (
                  <div className="table-title">
                    Free Plan
                    <div className="price">$0.00 / month</div>
                  </div>
                ),
                dataIndex: "free",
                key: "free",
                align: "center",
              },
              {
                title: (
                  <div className="table-title premium">
                    <span>
                      <img src={crown} alt="crown" /> Premium
                    </span>
                    <div className="price">
                      {subscriptionPlan === "1 Month" ? (
                        <>$49.98</>
                      ) : (
                        <>$39.98</>
                      )}
                      /month
                    </div>
                  </div>
                ),
                dataIndex: "premium",
                key: "premium",
                align: "center",
              },
            ]}
            dataSource={data}
            pagination={false}
          />
        )}
      </div>
    </div>
  );
};

export default Subscriptions;
